import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'section[knowledge-section]',
  imports: [],
  templateUrl: './knowledge-section.component.html',
  styleUrl: './knowledge-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KnowledgeSectionComponent { }
